import type {MergeSuggestion} from 'services/mergeSuggestions/types';
import type {WorkV4} from 'services/metadata/types';

const mapWorkName = (work?: WorkV4): string => {
  return work?.preferredTitle?.[0] ?? work?.originalTitle ?? '';
};

export const applyWorkTitlesToMergeSuggestions = (
  data: MergeSuggestion[],
  works: WorkV4[],
): MergeSuggestion[] => {
  if (works.length === 0) {
    return data;
  }

  return (data ?? []).map(d => {
    return {
      ...d,
      sourceName: mapWorkName(works.find(s => s.id === d.sourceId)),
      targetName: mapWorkName(works.find(s => s.id === d.targetId)),
    };
  });
};
